import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../../context/AuthContext";
import { useEffect, useState } from "react";
import api from "@api";
import "./StartPage.css";

function StartPage() {
    const navigate = useNavigate();
    const { user } = useAuth();

    const [myLeagues, setMyLeagues] = useState([]);

    useEffect(() => {
        const fetchMyLeagues = async () => {
            try {
                const res = await api.get("/api/directory/my-leagues");
                setMyLeagues(res.data || []);
            } catch (err) {
                console.error("Failed to fetch my leagues", err);
            }
        };

        fetchMyLeagues();
    }, []);

    const approvedClaim = myLeagues.find(
        (league) => league.status === "approved"
    );

    const pendingClaim = myLeagues.find(
        (league) => league.status === "pending"
    );

    const rejectedClaim = myLeagues.find(
        (league) => league.status === "rejected"
    );

    const handleClaimListing = () => {
        if (approvedClaim) {
            navigate(
                `/dashboard/directory/manage/${approvedClaim.directory_league_id}`
            );
            return;
        }

        if (pendingClaim) {
            navigate(`/leagues/${pendingClaim.directory_league_id}`);
            return;
        }

        if (rejectedClaim) {
            navigate(`/leagues/${rejectedClaim.directory_league_id}`);
            return;
        }

        navigate("/?claim=true");
    };

    return (
        <div className="startPage">
            <div className="startPage-card">
                <div className="startPage-header">
                    <p className="startPage-eyebrow">Welcome to SportingHip</p>

                    <h1>
                        Welcome{user?.username ? `, ${user.username}` : ""}
                    </h1>

                    <p className="startPage-subtitle">
                        Choose how you would like to get started.
                    </p>
                </div>

                <div className="startPage-grid">
                    <button
                        type="button"
                        className="startPage-option startPage-option-primary"
                        onClick={() => navigate("/dashboard/profile/create")}
                    >
                        <div className="startPage-iconWrap">
                            <span className="startPage-icon">👤</span>
                        </div>

                        <div className="startPage-content">
                            <div>
                                <p className="startPage-optionLabel">PERSONAL</p>
                                <h2>Set up my profile</h2>

                                <p>
                                    Create your personal SportingHip profile and start building
                                    your sports identity.
                                </p>
                            </div>

                            <span className="startPage-action">
                                Set Up Profile →
                            </span>
                        </div>
                    </button>

                    <button
                        type="button"
                        className="startPage-option"
                        onClick={handleClaimListing}
                    >
                        <div className="startPage-iconWrap">
                            <span className="startPage-icon">📍</span>
                        </div>

                        <div className="startPage-content">
                            <div>
                                <p className="startPage-optionLabel">DIRECTORY</p>

                                <h2>
                                    {approvedClaim
                                        ? "Listing claimed"
                                        : pendingClaim
                                            ? "Claim request pending"
                                            : rejectedClaim
                                                ? "Claim request not approved"
                                                : "Claim an existing listing"}
                                </h2>

                                <p>
                                    {approvedClaim
                                        ? "Your listing has been approved and is ready to manage."
                                        : pendingClaim
                                            ? "Your claim has been submitted and is currently under review."
                                            : rejectedClaim
                                                ? "Review the listing and submit another claim if needed."
                                                : "Found your league, club, or sports program in our directory? Claim it to manage its information."}
                                </p>
                            </div>

                            <span className="startPage-action">
                                {approvedClaim
                                    ? "Manage Listing →"
                                    : pendingClaim
                                        ? "View Listing →"
                                        : rejectedClaim
                                            ? "Review Listing →"
                                            : "Find My Listing →"}
                            </span>
                        </div>
                    </button>

                    {/*
          <button
            type="button"
            className="startPage-option"
            onClick={() => navigate("/dashboard/directory/create")}
          >
            <div className="startPage-iconWrap">
              <span className="startPage-icon">➕</span>
            </div>

            <div className="startPage-content">
              <div>
                <p className="startPage-optionLabel">DIRECTORY</p>
                <h2>Create a new listing</h2>

                <p>
                  Add your league, club, tournament, or sports program to
                  SportingHip.
                </p>
              </div>

              <span className="startPage-action">
                Create Listing →
              </span>
            </div>
          </button>
          */}
                </div>

                <div className="startPage-footer">
                    You can set up your profile now and connect additional leagues,
                    listings, or player profiles later.
                </div>
            </div>
        </div>
    );
}

export default StartPage;